import { CardActions, CardContent, CardHeader, IconButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Close } from "@mui/icons-material";
import React from 'react';
import { closeModal } from "../components";
import Card from './Card';
import View from './View';

class ModalPadrao extends React.Component {
  render() {
    const { classes, cardTitle, cardSubtitle, avatar, content, footer, action } = this.props;
    return (
      <Card style={{ marginTop: 50, width: "98%", }}>
        <CardHeader
          classes={{
            root: classes.newHead,
            title: classes.cardTitle,
            subheader: classes.cardSubtitle,
          }}
          title={cardTitle}
          subheader={cardSubtitle}
          action={
            // <View style={{ backgroundColor: "white", height: 25, width: 25, borderRadius: 12.5 }}>
              <IconButton
              size={'small'}
                style={{ backgroundColor: "white", alignSelf:'center', marginTop:7 }}
                onClick={() => {
                  closeModal()
                }}
              >
                <Close style={{ color: 'black' }} />
              </IconButton>
            // </View>
          }
        />
        <CardContent>
          {content}
        </CardContent>
        {footer !== undefined ? (<CardActions className={classes.cardActions}>
          {footer}
        </CardActions>) : null}
      </Card>
    );
  }
}



const regularCardStyle = {
  cardTitle: {
    color: '#FFFFFF',
    marginTop: '0',
    marginBottom: '5px',
    fontSize: '1.125em',
  },
  cardSubtitle: {
    marginBottom: '0',
    color: 'rgba(255, 255, 255, 0.62)',
    margin: '0 0 10px',
  },
  newHead: {
    color: "#fff",
    height: 55,
    padding: "0.75rem 1.25rem",
    marginBottom: 10,
    zIndex: "3 !important",
    boxShadow:
      "0 12px 20px -10px rgba(0, 0, 0, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 0, 0, 0.2)",
    background: "black",
    position: "relative",
    top: -15,
    borderRadius: 5
  }
};
export default withStyles(regularCardStyle)(ModalPadrao);
